import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import './List.css'; // Import the CSS file
import axios from 'axios'; // Import Axios for API calls

const ListDeals = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [userData, setUserData] = useState([]); // State for user data
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10); // Number of users per page
  const history = useHistory();
  const token = localStorage.getItem('authToken');

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/admin/getall-deals?page=${currentPage}&limit=${limit}&searchTerm=${searchQuery}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        setUserData(response.data.deals);
        setTotalPages(response.data.totalPages);
      } else {
        console.log("Error getting List");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleDownloadCSV = () => {
    const headers = [
      'S.No',
      'Title',
      'Description',
      'Coupon Code',
      'Category Name',
      'Brand Name',
      'Store Name',
      'Status',
      'Is Show',
      'Start Date',
      'End Date'
    ];
  
    const csvRows = [];
    csvRows.push(headers.join(','));
  
    userData.forEach((user, index) => {
      const row = [
        (currentPage - 1) * limit + index + 1,
        user.title,
        user.description,
        user.couponCode || 'N/A',
        user?.category?.[0]?.categoryName || 'N/A',
        user?.brands?.[0]?.name || 'N/A',
        user?.store?.[0]?.name || 'N/A',
        user.status,
        user.isShow ? 'Yes' : 'No',
        formatDate(user.startDate),  // Apply formatDate for CSV export
        formatDate(user.endDate)     // Apply formatDate for CSV export
      ];
  
      csvRows.push(row.join(','));
    });
  
    const csvBlob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
    const csvUrl = URL.createObjectURL(csvBlob);
    const link = document.createElement('a');
    link.href = csvUrl;
    link.download = 'deals_list.csv';
    link.click();
  };
  

  const handleEdit = (id) => {
    history.push(`/edit-deals/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      // Make the API call to delete the deal
      await axios.delete(`https://brand.aasmo.in/api/admin/delete-deals/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // Filter the deleted deal out of the userData array
      setUserData(userData.filter(deal => deal._id !== id));
      setShowModal(false); // Close the modal after deletion
    } catch (error) {
      console.error("Error deleting deal:", error);
    }
  };
  
  const handleDeleteClick = (id) => {
    setSelectedUserId(id); // Set the selected deal's ID
    setShowModal(true); // Show the confirmation modal
  };
  
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  const truncatedDescription = (description) => {
    const words = description.split(' '); // Split the description into words
    if (words.length <= 5) {
      return description; // Return the full description if it's 5 words or less
    }
    return words.slice(0, 5).join(' ') + '...'; // Join the first 5 words and add "..."
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      const response = await axios.put(
        `https://brand.aasmo.in/api/admin/update-deals/${id}`,
        { status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        fetchUserData(); // Refresh data after status update
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handleIsShowChange = async (id, currentStatus) => {
    const newIsShowStatus = currentStatus === true ? false : true; // Toggle the boolean value
    try {
      const response = await axios.put(
        `https://brand.aasmo.in/api/admin/update-deals/${id}`,
        { isShow: newIsShowStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        fetchUserData(); // Refresh data after toggling show status
      }
    } catch (error) {
      console.error("Error toggling isShow:", error);
    }
  };
  

  // Fetch user data from API
  useEffect(() => {
    fetchUserData();
  }, [currentPage, limit, searchQuery]); // Dependencies

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>List Deals</h2>
        </div>
        <div className="body">
          {/* Search Input */}
          <div className="d-flex justify-content-between">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search by Title & Description"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
        
       <div>
       <button onClick={handleDownloadCSV} className="btn btn-primary">
            Download CSV
          </button>
       </div>
          </div>
          <div className="table-responsive">
            <table className="table table-hover">
              <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                <tr>
                  <th>S.No</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Coupon Code </th>
                  <th>Category Name </th>
                  <th>Brand Name </th>
                  <th>Store Name </th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Status</th>
                  <th>Is Show</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: "center" }}>
                {userData.map((user, index) => (
                  <tr key={user.id}>
                    <td>{(currentPage - 1) * limit + index + 1}</td>
                    <td>{user.title}</td>
                    <td>{truncatedDescription(user.description)}</td>
                    <td>{user?.couponCode || 'N/A'}</td>
                    <td>{user?.category?.[0]?.categoryName || 'N/A'}</td>
                    <td>{user?.brands?.[0]?.name || 'N/A'}</td>
                    <td>{user?.store?.[0]?.name || 'N/A'}</td>
                    <td>{formatDate(user.startDate)}</td>
                    <td>{formatDate(user.endDate)}</td>
                    <td>
  <select
    value={user?.status} // Ensure this reflects the correct status from the API
    onChange={(e) => handleStatusChange(user._id, e.target.value)}
  >
    <option value="active">Active</option>
    <option value="inactive">Inactive</option>
  </select>
</td>


<td>
  <label className="switch">
    <input
      type="checkbox"
      checked={user.isShow === true}  // Compare with a boolean value
      onChange={() => handleIsShowChange(user._id, user.isShow)}
    />
    <span className="slider round"></span>
  </label>
</td>

                    <td>
                      <i className="icon-pencil" onClick={() => handleEdit(user._id)}></i>
                      &nbsp;&nbsp;
                      <i className="fa fa-trash-o" onClick={() => handleDeleteClick(user._id)}></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          <div className="body">
            <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </NavLink>
                </li>
                {[...Array(totalPages).keys()].map(page => (
                  <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                    <NavLink
                      to="#"
                      className="page-link"
                      onClick={() => handlePageChange(page + 1)}
                    >
                      {page + 1}
                    </NavLink>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <ConfirmDeleteModal
  show={showModal}
  handleClose={() => setShowModal(false)}
  handleConfirm={() => handleDelete(selectedUserId)} // Correct id passed here
/>

    </div>
  );
};

export default ListDeals;
